import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import InvestorPortal from './pages/InvestorPortal';
import BusinessModelCanvas from './pages/BusinessModelCanvas';
import TermsOfService from './pages/TermsOfService';
import PrivacyPolicy from './pages/PrivacyPolicy';
import AboutUs from './pages/AboutUs';
import Safety from './pages/Safety';
import DeleteAccount from './pages/DeleteAccount';
import AppShell from './pages/AppShell';
import ZileeChat from './components/ZileeChat';
import './App.css';

function App() {
  // When launched as an installed PWA (standalone), never get stuck on the
  // marketing/Heroes root — jump straight into the delivery app. This is robust
  // even for older installs whose baked start_url points at "/". Regular browser
  // visitors are not standalone, so the marketing site stays intact for them.
  useEffect(() => {
    const isStandalone =
      (window.matchMedia && (
        window.matchMedia('(display-mode: standalone)').matches ||
        window.matchMedia('(display-mode: fullscreen)').matches ||
        window.matchMedia('(display-mode: minimal-ui)').matches
      )) ||
      window.navigator.standalone === true;
    if (isStandalone && window.location.pathname === '/') {
      window.location.replace('/app/index.html');
    }
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/app" element={<AppShell />} />
        <Route path="/investor-portal" element={<InvestorPortal />} />
        <Route path="/business-model-canvas" element={<BusinessModelCanvas />} />
        <Route path="/terms" element={<TermsOfService />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/safety" element={<Safety />} />
        <Route path="/delete-account" element={<DeleteAccount />} />
      </Routes>
      <ZileeChat />
    </BrowserRouter>
  );
}

export default App;
